import { CATALOG_ROUTES } from './constants';
import CatalogLayout from './components/CatalogLayout';

export default [
    {
        path: CATALOG_ROUTES.LIST,
        component: CatalogLayout
    }
];
